<div class="dependency-wrapper radius-8 border-20 m-b-10 p-t-15 p-r-15 p-l-15">
  <div class="details dis-flex flex-col">
    <div
      class="wp-wrapper dis-flex"
      *ngIf="raiseByMeList?.milestone?.quarterly_outcomes?.workpackage_id"
    >
      <p class="wp-heading b3 font-medium text-90 m-b-0">Work Package:</p>
      <p class="wp-title b3 text-90 m-b-0">
        {{ raiseByMeList?.milestone?.quarterly_outcomes?.workpackage?.name }}
      </p>
    </div>
    <div class="dis-flex flex-sb flex-m m-b-4 m-t-15">
      <div class="dis-flex">
      <p-avatar
        class="outcome-dependency-avatar m-r-5 p-avatar-square"
        [image]="raiseByMeList?.user?.avatar"
      />
      <div class="dependency-person">
        <p class="b2 font-medium text-80 m-b-0 lh-1-5">
          {{ raiseByMeList?.user?.name }}
        </p>
        <p class="b3 text-50 m-b-0 lh-1-5">
          {{ raiseByMeList?.user?.designation }}
        </p>
      </div>
    </div>
    <div
      class="discussion-ongoing-tag p-t-3 p-b-4 p-r-10 p-l-20"
      *ngIf="raiseByMeList?.status == 6"
    >
      <p class="b3 text-primary m-b-0">Discussion Ongoing</p>
    </div>
  </div>
    
    <div class="milestone-title b1 text-90 m-t-10">
      {{ raiseByMeList?.milestone?.value }}
    </div>
    <div class="dependency-btn-wrapper dis-flex m-t-10 m-b-15">
      <button
        class="btn delete b2 wd-150px"
        (click)="onWithdraw()"
        *ngIf="raiseByMeList?.status == 0 || raiseByMeList?.status == 6"
      >
        <ng-icon class="m-r-5 lh-1-0" size="20" name="hugeCancelCircle" />
        Withdraw
      </button>
      <button
        class="btn success b2 wd-150px"
        *ngIf="raiseByMeList?.status > 0 && raiseByMeList?.status < 6"
      >
        <ng-icon class="m-r-5 lh-1-0" size="18" name="hugeCheckmarkCircle04" />
        Accepted
      </button>
      <button
        class="btn delete b2 wd-150px"
        *ngIf="this.raiseByMeList?.status == 7"
      >
        <ng-icon class="m-r-5 lh-1-0" size="20" name="hugeCancelCircle" />
        Withdrawn
      </button>
      <p-divider
        class="vertical-divider m-t-6"
        layout="vertical"
        *ngIf="raiseByMeList?.status == 0 || raiseByMeList?.status == 6"
      />
      <button
        (click)="onReassign()"
        class="btn outline b2 wd-150px"
        *ngIf="raiseByMeList?.status == 0 || raiseByMeList?.status == 6"
      >
        <ng-icon class="m-r-5 lh-1-0" size="17" name="hugeUserCheck01" />
        Re-assign
      </button>
    </div>
  </div>
</div>

<!-- Withdraw Dependency Modal -->
<p-dialog
  header="Withdraw Dependency?"
  class="action-item-modal b1 font-medium"
  [modal]="true"
  [(visible)]="withdrawDependency"
  [style]="{ width: '30rem' }"
>
  <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
    <div class="dis-flex flex-col">
      <p class="b2 m-b-0 text-70">
        Are you sure, you want to
        <span class="font-medium text-80">Withdraw Dependency</span> raised to
        <span class="font-medium text-80">{{ raiseByMeList?.user?.name }}</span>?
      </p>
    </div>
  </div>
  <div class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15">
    <button class="btn outline wd-100px m-r-10" (click)="closeWithdrawn()">
      Cancel
    </button>
    <button class="btn delete wd-100px" (click)="withdraw()">Withdraw</button>
  </div>
</p-dialog>

<!-- delegate Dependency Modal -->
<p-dialog
  header="Re-assign Dependency?"
  class="action-item-modal b1 font-medium"
  [modal]="true"
  [(visible)]="reassignDependency"
  [style]="{ width: '30rem' }"
>
  <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25 dis-flex">

    <div class="dis-flex flex-col wd-50">
      <label for="username" class="b2 font-medium m-b-5 text-80">Group</label>
      <p-dropdown
        [options]="overAllGroupData"
        [(ngModel)]="selectedGroup"
        optionLabel="name"
        placeholder="Select Group"
        filter="true"
        (onFilter)="onOverAllSearchChange($event)"
        (onChange)="onGroupDataChange()"
        [overlayOptions]="helper.getOverlayOptions()"
      ></p-dropdown>
    </div>

    <div class="dis-flex flex-col wd-50" *ngIf="selectedGroup">
      <label class="b2 font-medium m-b-5 text-80">Team Member</label>
      <p-dropdown
      id="dropdown-memberList"
      name="user_id"
      [style]="{'width':'100%'}"
      [options]="groupMemberList"
      placeholder="Select an option"
      filter="true"
      (onChange)="onDropdownChange($event)"
      filterPlaceholder="Search"
      (onFilter)="onTeamSearch($event)"
      optionLabel="name"
      [(ngModel)]="selectedGroupMember" 
      [overlayOptions]="helper.getOverlayOptions()"
    >
    </p-dropdown>
    </div>
  </div>
  <div class="col-md-12">
    
  </div>
  <div class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15">
    <button class="btn outline wd-100px m-r-10" (click)="closeReassign()">
      Cancel
    </button>
    <button class="btn outline b2 wd-100px"  [disabled]="!selectedGroupMember" (click)="reassign()">Re-assign</button>
  </div>
</p-dialog>
